/* eslint-disable @typescript-eslint/naming-convention */
import type { TranslationTag } from '@ps/web-core-intl';
import type { Reference } from '@ps/web-martech-cms-types';
import React from 'react';

import { CMSPageSection } from '@swf/cms';

import MatchGridItem from './MatchGridItem';

interface Props {
  dataRef: Reference[];
  previewTranslation: TranslationTag;
  reportTranslation: TranslationTag;
}

const MatchGrid: React.FC<Props> = ({ dataRef, previewTranslation, reportTranslation }) => (
  <CMSPageSection columns={3} grid>
    {dataRef.map((itemRef: Reference) => (
      <MatchGridItem
        key={itemRef.uid}
        itemRef={itemRef}
        previewTranslation={previewTranslation}
        reportTranslation={reportTranslation}
      />
    ))}
  </CMSPageSection>
);

export default MatchGrid;
